import React from 'react';

export default function Notifications() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='#27272A'
      />
      <g clipPath='url(#clip0_321_1134)'>
        <path
          d='M14.8664 22C14.978 22.2029 15.142 22.3722 15.3414 22.4901C15.5407 22.608 15.7681 22.6702 15.9997 22.6702C16.2313 22.6702 16.4587 22.608 16.658 22.4901C16.8574 22.3722 17.0215 22.2029 17.133 22M10.6663 9.33331C9.86634 10.4666 9.33301 11.8 9.33301 13.3333M22.6663 13.3333C22.6663 11.8 22.133 10.4666 21.333 9.33331M11.9997 13.3333C11.9997 12.2724 12.4211 11.255 13.1712 10.5049C13.9214 9.75474 14.9388 9.33331 15.9997 9.33331C17.0605 9.33331 18.078 9.75474 18.8281 10.5049C19.5782 11.255 19.9997 12.2724 19.9997 13.3333C19.9997 18 21.9997 19.3333 21.9997 19.3333H9.99967C9.99967 19.3333 11.9997 18 11.9997 13.3333Z'
          stroke='#A1A1AA'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_321_1134'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(8 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
